import axios, { AxiosInstance } from 'axios';
import AxiosRepository from './axios.repository';
import { IAdminFacilitiesListParams, IFacilityRepository } from '@common/interfaces';
import { decoupledClientInstance } from '@common/utils/axios';

class FacilityRepository extends AxiosRepository implements IFacilityRepository {
  public constructor(protected authClient: AxiosInstance) {
    super((decoupledClientInstance as any).create(), authClient);
  }

  // Note: get locally with clean instance of axios
  async getGeoJSON() {
    const { data } = await axios.get('/countries.geo.json');
    return data;
  }

  async getFacilities() {
    const { data } = await this.get('/facilities/');
    return data;
  }

  async getFacility(facilityId: string) {
    const { data } = await this.get(`/facilities/${facilityId}/`);
    return data;
  }

  async getFocalPoints(facilityId: string) {
    // Note: if we need more focal points - we should make loading options
    const { data } = await this.get(`/facilities/${facilityId}/focal-points/`, {
      params: {
        limit: 100,
      },
    });
    return data;
  }

  async getAdminFacilities(params?: IAdminFacilitiesListParams) {
    const { data } = await this.get(`/facilities/management/`, { params });
    return data;
  }

  async getAdminFacilitisFilters() {
    const { data } = await this.get('/facilities/management/filters/');
    return data;
  }
}

export default FacilityRepository;
